// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>Copyright © Reedme 2024</p>
      </div>
    </footer>
  );
}

export default Footer;

